import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useDeleteCustomModel = (authToken: string) => {
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (modelId: string) =>
      fetch(ENDPOINTS.delete_custom_model(String(workspaceId), modelId), {
        method: "DELETE",
        headers: jsonAuthHeaders(authToken),
      }).then(handleResponse),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", workspaceId],
      });
      queryClient.invalidateQueries({
        queryKey: ["custom-models", workspaceId],
      });
    },
  });
};
